"use client";
import React, { useEffect, useState } from "react";
import Nav from "@/components/nav";
import CartButton from "@/components/cartButton";
import NavTrigger from "./navtrigger";
import Image from "next/image";
import { useAppContext } from "@/context/AppProvider";
import fetchGraphQL from "@/helper/fetch";
import { useRouter } from "next/navigation";

async function SearchProducts(searchText) {
  const QUERY = `query {
      productCollection(where: { name_contains: "${searchText}" }) {
          items {
              _id,
              name,
              price,
              discount,
              image {
                  url
              }
          }
      }
  }`;

  const result = await fetchGraphQL(QUERY);
  console.log(result, "result");

  return result.data?.productCollection.items?.map((item) => ({
    key: item._id,
    image: item.image.url,
    discount: item.discount,
    title: item.name,
    price: item.price,
  }));
}

function Header() {
  const [cartItemsChecked, setcartItemsChecked] = useState(false);
  const { cartItems, setCartItems } = useAppContext();

  useEffect(() => {
    if (cartItemsChecked) {
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
    }
  }, [cartItems, cartItemsChecked]);

  useEffect(() => {
    const cartItemsFound = localStorage.getItem("cartItems");
    console.log("cartItems found", cartItems);
    if (cartItemsFound) {
      setCartItems(JSON.parse(cartItemsFound));
    }
    setcartItemsChecked(true);
  }, []);

  const [searchText, setSearchText] = useState("");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (searchText.length > 2) {
      SearchProducts(searchText).then((data) => {
        console.log(data, "result2");
        if (data) {
          setProducts(data);
        } else {
        }
      });
    }
  }, [searchText]);
  const router = useRouter();

  return (
    <header className="header">
      <div className="tab">
        {/* <div className="shell"> */}
        <div className="tab__inner mx-2">
          <p>
            Телефон за връзка: <a href="tel:+359894931124">+359 89 493 1124</a>
          </p>

          <ul className="socials">
            <li>
              <a
                href="https://www.facebook.com/people/Akashi-Store/61552123115942"
                className="icon-circle"
              >
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.70873 12.6795V7.126H0.839844V4.96167H2.70873V3.36554C2.70873 1.51325 3.84005 0.504639 5.49242 0.504639C6.28392 0.504639 6.96418 0.563568 7.16243 0.589907V2.52566L6.01642 2.52618C5.11776 2.52618 4.94376 2.95321 4.94376 3.57984V4.96167H7.08697L6.80791 7.126H4.94376V12.6795H2.70873Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </li>

            <li>
              <a
                href="https://www.instagram.com/akashistore.bulgaria/"
                className="icon-circle"
              >
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00076 1.82294C8.80947 1.82294 9.02366 1.82971 9.73818 1.86229C10.1678 1.86755 10.5933 1.94644 10.9962 2.09552C11.2884 2.20821 11.5538 2.38084 11.7753 2.60229C11.9967 2.82375 12.1694 3.08912 12.282 3.38133C12.4311 3.78427 12.51 4.20979 12.5153 4.63939C12.5475 5.35391 12.5546 5.5681 12.5546 7.37681C12.5546 9.18552 12.5479 9.39971 12.5153 10.1142C12.51 10.5438 12.4311 10.9694 12.282 11.3723C12.1694 11.6645 11.9967 11.9299 11.7753 12.1513C11.5538 12.3728 11.2884 12.5454 10.9962 12.6581C10.5933 12.8072 10.1678 12.8861 9.73818 12.8913C9.02398 12.9236 8.80979 12.9307 7.00076 12.9307C5.19172 12.9307 4.97753 12.9239 4.26334 12.8913C3.83373 12.8861 3.40821 12.8072 3.00527 12.6581C2.71307 12.5454 2.44769 12.3728 2.22624 12.1513C2.00479 11.9299 1.83216 11.6645 1.71947 11.3723C1.57038 10.9694 1.4915 10.5438 1.48624 10.1142C1.45398 9.39971 1.44689 9.18552 1.44689 7.37681C1.44689 5.5681 1.45366 5.35391 1.48624 4.63939C1.4915 4.20979 1.57038 3.78427 1.71947 3.38133C1.83216 3.08912 2.00479 2.82375 2.22624 2.60229C2.44769 2.38084 2.71307 2.20821 3.00527 2.09552C3.40821 1.94644 3.83373 1.86755 4.26334 1.86229C4.97785 1.83004 5.19205 1.82294 7.00076 1.82294ZM7.00076 0.602295C5.16205 0.602295 4.93043 0.610037 4.20785 0.64294C3.64561 0.654123 3.08934 0.760579 2.56269 0.957779C2.11092 1.12799 1.70172 1.39473 1.36366 1.73939C1.01869 2.07758 0.751722 2.487 0.581401 2.93907C0.384201 3.46571 0.277746 4.02199 0.266563 4.58423C0.234304 5.30617 0.226562 5.53778 0.226562 7.37649C0.226562 9.2152 0.234304 9.44681 0.267208 10.1694C0.278391 10.7316 0.384847 11.2879 0.582046 11.8146C0.752178 12.2666 1.01892 12.676 1.36366 13.0142C1.70191 13.359 2.11133 13.6257 2.56334 13.7958C3.08998 13.993 3.64626 14.0995 4.2085 14.1107C4.93108 14.1429 5.16172 14.1513 7.0014 14.1513C8.84108 14.1513 9.07172 14.1436 9.7943 14.1107C10.3565 14.0995 10.9128 13.993 11.4395 13.7958C11.8893 13.6215 12.2978 13.3551 12.6389 13.0138C12.98 12.6726 13.246 12.2639 13.4201 11.8139C13.6173 11.2873 13.7238 10.731 13.735 10.1687C13.7672 9.44681 13.775 9.2152 13.775 7.37649C13.775 5.53778 13.7672 5.30617 13.7343 4.58358C13.7231 4.02134 13.6167 3.46507 13.4195 2.93842C13.2493 2.48642 12.9826 2.077 12.6379 1.73875C12.2996 1.39401 11.8902 1.12727 11.4382 0.957134C10.9115 0.759934 10.3553 0.653478 9.79301 0.642295C9.07108 0.610037 8.83947 0.602295 7.00076 0.602295Z"
                    fill="currentColor"
                  />
                  <path
                    d="M7.00215 3.89917C6.31413 3.89917 5.64155 4.10319 5.06948 4.48544C4.49741 4.86768 4.05154 5.41098 3.78824 6.04663C3.52494 6.68229 3.45605 7.38174 3.59028 8.05654C3.72451 8.73135 4.05582 9.35119 4.54233 9.8377C5.02884 10.3242 5.64868 10.6555 6.32349 10.7897C6.99829 10.924 7.69774 10.8551 8.33339 10.5918C8.96904 10.3285 9.51234 9.88262 9.89459 9.31055C10.2768 8.73848 10.4809 8.0659 10.4809 7.37788C10.4809 6.45527 10.1144 5.57045 9.46197 4.91806C8.80958 4.26568 7.92476 3.89917 7.00215 3.89917ZM7.00215 9.63594C6.55555 9.63594 6.11897 9.50351 5.74764 9.25539C5.3763 9.00727 5.08688 8.65461 4.91597 8.242C4.74506 7.8294 4.70034 7.37537 4.78747 6.93735C4.8746 6.49933 5.08966 6.09698 5.40546 5.78119C5.72125 5.46539 6.1236 5.25033 6.56162 5.1632C6.99964 5.07608 7.45367 5.12079 7.86627 5.2917C8.27888 5.46261 8.63154 5.75203 8.87966 6.12337C9.12778 6.4947 9.26021 6.93128 9.26021 7.37788C9.26021 7.97676 9.02231 8.5511 8.59884 8.97457C8.17537 9.39804 7.60102 9.63594 7.00215 9.63594Z"
                    fill="currentColor"
                  />
                  <path
                    d="M10.6176 4.5738C11.0665 4.5738 11.4305 4.20986 11.4305 3.7609C11.4305 3.31195 11.0665 2.948 10.6176 2.948C10.1686 2.948 9.80469 3.31195 9.80469 3.7609C9.80469 4.20986 10.1686 4.5738 10.6176 4.5738Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </li>

            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.anime_shuffler.anime_generator"
                className="icon-circle"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.88 6.26l1.43-2.48a.5.5 0 00-.86-.5l-1.5 2.6a7.94 7.94 0 00-8.92 0l-1.5-2.6a.5.5 0 10-.86.5l1.43 2.48a7.99 7.99 0 00-3.88 6.87v5.88c0 .82.67 1.5 1.5 1.5h2a1.5 1.5 0 001.5-1.5v-3.5h8v3.5c0 .82.67 1.5 1.5 1.5h2a1.5 1.5 0 001.5-1.5V13.13a7.99 7.99 0 00-3.88-6.87zM7.5 14.63a1 1 0 110-2 1 1 0 010 2zm9 0a1 1 0 110-2 1 1 0 010 2z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
        {/* </div> */}
      </div>
      <div className="w-full">
        <div className="flex w-full items-center justify-between md:px-6 py-4  px-2">
          <div className="col-span-1 flex justify-start">
            <a href="/" className="logo">
              <Image
                src="/temp/logo.png"
                alt="akashistore"
                className=" h-10  md:h-20"
                width={200}
                height={100}
              />
            </a>
          </div>
          {/* Nav Links - Hidden on small screens */}
          <div className="col-span-2 flex ">
            <Nav cartItems={cartItems} />
          </div>
          {/* Search Bar - Hidden on small screens */}
          <div className="col-span-1  flex">
            <div className="relative">
              <div className="flex items-center bg-gray-100 rounded-full px-4 py-2 w-full md:w-80">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-4.35-4.35m1.85-4.15a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Search for products..."
                  className="bg-transparent focus:outline-none text-gray-700 ml-2 w-full"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {searchText.length > 2 && (
                <div className="absolute z-10 w-full md:w-80 mt-1 bg-white border border-gray-200 rounded shadow-lg max-h-[400px] overflow-y-auto">
                  {products.length > 0 ? (
                    <>
                      {products.map((product, index) => (
                        <div
                          key={index}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex h-16 border-gray border-b-2"
                          // onClick={() => {
                          //   setSearchText(product); // Set the selected product as search text
                          //   setFilteredProducts([]); // Clear dropdown
                          // }}
                          onClick={() => {
                            setProducts([]);
                            setSearchText("");
                            router.push(
                              `/products/${encodeURIComponent(product.title)}`
                            );
                          }}
                        >
                          {/* {product} */}
                          <div className="min-w-14 bg-black flex">
                            <Image
                              src={product.image}
                              width={60}
                              height={80}
                              objectFit="contain"
                            />
                          </div>
                          <div className="flex line-clamp-2">
                            {product.title}
                          </div>
                          <div className="whitespace-nowrap text-sm text-[green]">
                            {product.price} лв.
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex border-gray border-b-2">
                      Products not found.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* Cart and Avatar Icons */}
          <div className="col-span-1  items-center gap-2 hidden md:flex ">
            <CartButton itemsLength={cartItems.length} />
            {/* <Avatar /> */}
          </div>{" "}
          {/* Hamburger Menu - Visible only on small screens */}
          <div className="col-span-1 lg:hidden flex justify-end">
            <NavTrigger />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
